module.exports = __webpack_public_path__ + "img/IMG_20190123_113358.de37f4f5.jpg";